var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-google-autocomplete',{ref:"address",attrs:{"id":"map","classname":"p-inputtext p-component","placeholder":_vm.$t('address'),"types":"(cities)"},on:{"keyup":_vm.keyhandler,"placechanged":_vm.getAddressData}})}
var staticRenderFns = []

export { render, staticRenderFns }